const TIP_STRIP_PATTERNS = [
  /\b(?:con\s+)?\$?\s*[\d][\d.,]*\s*(?:de\s+)?propina\b/gi,
  /\bpropina\s+(?:de\s+)?\$?\s*[\d][\d.,]*\b/gi,
  /\b(\d{1,3})\s*(?:lucas?|gambas?)\s+(?:de\s+)?propina\b/gi,
  /\bpropina\s+(?:de\s+)?(\d{1,3})\s*(?:lucas?|gambas?)\b/gi,
  /\b(?:propina\s+)?(\d{1,2})\s*%\s*(?:de\s+)?propina\b/gi,
  /\bpropina\s+(?:del?\s+)?(\d{1,2})\s*%\b/gi,
  /\b(?:deja|dejar|suma|sumale|sumá)\s+(?:una\s+)?propina\s+(?:de\s+)?\$?\s*[\d][\d.,]*\b/gi,
];

function parseFixedTipAmount(raw) {
  const lucasDe = raw.match(/\b(\d{1,3})\s*(?:lucas?|gambas?)\s+(?:de\s+)?propina\b/i);
  if (lucasDe) {
    const n = Number(lucasDe[1]);
    if (n > 0) return n * 1000;
  }
  const propinaLucas = raw.match(/\bpropina\s+(?:de\s+)?(\d{1,3})\s*(?:lucas?|gambas?)\b/i);
  if (propinaLucas) {
    const n = Number(propinaLucas[1]);
    if (n > 0) return n * 1000;
  }
  const patterns = [
    /\b(?:con\s+)?\$?\s*([\d][\d.,]*)(?!%)\s*(?:de\s+)?propina\b/i,
    /\bpropina\s+(?:de\s+)?\$?\s*([\d][\d.,]*)(?!%)\b/i,
    /\b(?:deja|dejar|suma|sumale|sumá)\s+(?:una\s+)?propina\s+(?:de\s+)?\$?\s*([\d][\d.,]*)(?!%)\b/i,
  ];
  for (const rx of patterns) {
    const m = raw.match(rx);
    if (!m) continue;
    const digits = String(m[1] || '').replace(/\./g, '').replace(',', '.');
    const n = Number(digits);
    if (Number.isFinite(n) && n > 0) return Math.round(n);
  }
  return null;
}

function parseTipPercent(raw) {
  const m =
    raw.match(/\b(?:propina\s+)?(\d{1,2})\s*%\s*(?:de\s+)?propina\b/i) ||
    raw.match(/\bpropina\s+(?:del?\s+)?(\d{1,2})\s*%/i);
  if (!m) return null;
  const pct = Number(m[1]);
  if (!Number.isFinite(pct) || pct <= 0 || pct > 100) return null;
  return pct;
}

export function trimOrphanTrailingCon(text) {
  return String(text || '')
    .replace(/\s+con\s*$/i, '')
    .replace(/\s+/g, ' ')
    .trim();
}

/**
 * @param {string} text
 * @returns {{ amount: number|null, percent: number|null }}
 */
export function parseTipFromText(text) {
  const raw = String(text || '');
  if (!/\bpropina\b/i.test(raw) && !/\b\d{1,2}\s*%\s*(?:de\s+)?propina\b/i.test(raw)) {
    return { amount: null, percent: null };
  }
  const amount = parseFixedTipAmount(raw);
  const percent = amount == null ? parseTipPercent(raw) : null;
  return { amount, percent };
}

/**
 * @param {string} text
 * @returns {{ rest: string, tip: number|null, tipPercent: number|null }}
 */
export function stripTipClause(text) {
  const raw = String(text || '').trim();
  const { amount, percent } = parseTipFromText(raw);
  if (amount == null && percent == null) {
    return { rest: raw, tip: null, tipPercent: null };
  }
  let rest = raw;
  for (const rx of TIP_STRIP_PATTERNS) {
    rest = rest.replace(rx, ' ');
  }
  rest = rest.replace(/\bpropina\b/gi, ' ').replace(/\s+/g, ' ').trim();
  rest = trimOrphanTrailingCon(rest);
  return { rest, tip: amount, tipPercent: percent };
}
